import { createApiMutationHook, IApiMutationFunction } from "@sol/sdk/utils/api";
import { mapRelationalValue, RelationalValue } from "@sol/sdk/utils/filters";

import { IBriefResource } from "../../briefs";
import { IClassroomResource } from "../../classrooms";

export enum AIMessageRole {
    User = "user",
    Assistant = "assistant",
}

export interface IAIChatMessage {
    role: AIMessageRole;
    message: string;
    timestamp?: string;
    interactionUuid?: string; // UUID of the specific question-response exchange in DB (not the entire conversation)
}

export type IAIMessageSendMutationParameters = {
    classroom: RelationalValue<IClassroomResource>;
    brief: RelationalValue<IBriefResource>;
    interactions: IAIChatMessage[];
};

export type IAIMessageSendMutationMutationResult = IAIChatMessage;

export const aiMessageSendMutation: IApiMutationFunction<IAIMessageSendMutationParameters> = ({
    classroom,
    brief,
    interactions,
}) => {
    return {
        method: "POST",
        url: `/ai`,
        data: {
            classroomId: mapRelationalValue(classroom),
            briefId: mapRelationalValue(brief),
            interactions,
        },
    };
};

export const useAIMessageSendMutation = createApiMutationHook<
    IAIMessageSendMutationParameters,
    IAIMessageSendMutationMutationResult
>(aiMessageSendMutation);
